import React from 'react'
import { useSelector } from 'react-redux'

import Avatar from '@/components-latest/primitives/Avatar'
import Text from '@/components-latest/primitives/Text'
import TruncateWithTooltip from '@/components-latest/primitives/Tooltip/TruncateWithTooltip'
import { ApiMenuItem } from '@/ducks/menu/menu.types'
import { selectCurrencySymbol } from '@/ducks/store/selectors/store.selectors'
import { useServerTranslation } from '@/hooks/useServerTranslation/useServerTranslation'
import { formatPrice } from '@/utils/currency.utils'

import Styles from './MenuItemCard.module.scss'

type IMenuItemCardProps = Pick<ApiMenuItem, 'name' | 'price' | 'avatar' | '_id'>

const MenuItemCard: React.FC<IMenuItemCardProps> = ({
  name,
  price,
  avatar,
  _id
}) => {
  const currencySymbol = useSelector(selectCurrencySymbol) || ''

  const { getTranslation } = useServerTranslation()

  return (
    <div className={Styles.card} data-testid={`menu-item-${_id}`}>
      <div className={Styles.avatarWrapper}>
        <Avatar
          className={Styles.avatar}
          image={avatar}
          squared
          size="medium"
          string={getTranslation(name)}
        />
      </div>
      <div className={Styles.textContent}>
        <TruncateWithTooltip asChild>
          <Text variant="nextBody" weight="semiBold">
            {getTranslation(name)}
          </Text>
        </TruncateWithTooltip>
        <TruncateWithTooltip asChild>
          <Text variant="nextSubtitle">
            {formatPrice(price, currencySymbol, {
              signDisplay: 'auto',
              minimumFractionDigits: 0
            }).replace(/\s([^\s]*)$/, '$1')}
          </Text>
        </TruncateWithTooltip>
      </div>
    </div>
  )
}

export default MenuItemCard
